import { render, staticRenderFns } from "./PlantListPage.vue?vue&type=template&id=8aec4f98&"
import script from "./PlantListPage.vue?vue&type=script&lang=ts&"
export * from "./PlantListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports